import { render, staticRenderFns } from "./PopUpViewProfile.vue?vue&type=template&id=7c7fbd02"
import script from "./PopUpViewProfile.vue?vue&type=script&lang=js"
export * from "./PopUpViewProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports